import cn from './item-form.module.css';

interface ItemFormBlockProps {
  title: string;
  children: React.JSX.Element;
}

const ItemFormBlock = ({ title, children }: ItemFormBlockProps) => (
  <div className={cn.itemFormBlock}>
    <div className={cn.itemFormBlockTitle}>{title}</div>
    <div className={cn.itemFormBlockContent}>{children}</div>
  </div>
);

export default ItemFormBlock;
